export default {
	SUPER_ADMIN: "superadmin",
	ADMIN: "admin",
	USER: "user",
}
